import { useWindowSize } from 'react-use';
import { numeric } from 'shared-base';
import { Wrapper } from './Resolution.style';

export type ResolutionProps = {};

export function Resolution(_props: ResolutionProps) {
  const { width, height } = useWindowSize();
  return (
    <Wrapper className='Resolution-wrapper' data-testid='Resolution-wrapper'>
      {numeric(width)} x {numeric(height)}
    </Wrapper>
  );
}

export default Resolution;
